import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';
import { OfflineLevelEnum } from '../enums/offlineLevelEnum';
import { getSettingsItem, putSettingsItem } from 'src/api/offline/offlineSettingsApi';

type ConnectionContextType = {
    connectionStatus: HubConnectionState;
    setConnectionStatus: (hubConnectionState: HubConnectionState) => void;
    hubConnection: HubConnection | null;
    setHubConnection: (hub: HubConnection | null) => void;
    connectedVesselGroup: number | null;
    setConnectedVesselGroup: (n: number) => void;
    offlineLevel: OfflineLevelEnum;
    isOffline: boolean;
    setOfflineLevel: (status: OfflineLevelEnum) => void;
    isOfflineSimulated: () => Promise<boolean>;
    setIsOfflineSimulated: (value: boolean) => Promise<void>;
};
export const ConnectionContext = React.createContext<ConnectionContextType>(undefined!);

export const ConnectionProvider = ({ children }: ContextProps) => {
    const [connectionStatus, setConnectionStatus] = useState<HubConnectionState>(HubConnectionState.Disconnected);
    const [hubConnection, setHubConnection] = useState<HubConnection | null>(null);
    const [connectedVesselGroup, setConnectedVesselGroup] = useState<number>(null);
    const [offlineLevel, setOfflineLevel] = useState<OfflineLevelEnum>(OfflineLevelEnum.Offline);

    const isOfflineSimulated = async () => {
        const isOfflineSimulated = await getSettingsItem('isOfflineSimulated');
        return isOfflineSimulated?.isOfflineSimulated;
    };

    const setIsOfflineSimulated = async (value: boolean) => {
        setOfflineLevel(value === true ? OfflineLevelEnum.Offline : OfflineLevelEnum.Online);
        putSettingsItem({ isOfflineSimulated: value }, 'isOfflineSimulated');
    };

    const isOffline = offlineLevel !== OfflineLevelEnum.Online;

    return (
        <ConnectionContext.Provider
            value={{
                connectionStatus,
                setConnectionStatus,
                hubConnection,
                setHubConnection,
                connectedVesselGroup,
                setConnectedVesselGroup,
                offlineLevel,
                setOfflineLevel,
                isOfflineSimulated,
                setIsOfflineSimulated,
                isOffline,
            }}
        >
            {children}
        </ConnectionContext.Provider>
    );
};

export const useConnectionStore = () => useContext(ConnectionContext);
